import { inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Actions, createEffect, ofType, ROOT_EFFECTS_INIT } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { DossierGet, DossierGetSuccess } from '@stores/dossier/dossier-ngrx.action';
import { isLogged } from '@wizbii-utils/angular/stores';
import { FibiiWebservice } from '@wizbii-utils/angular/webservices';
import { filter, map, switchMap, tap } from 'rxjs';

export const initDossiers = createEffect(
  (actions$ = inject(Actions), store = inject(Store)) =>
    actions$.pipe(
      ofType(ROOT_EFFECTS_INIT),
      switchMap(() => store.select(isLogged)),
      filter((logged) => logged),
      map(() => DossierGet({}))
    ),
  { functional: true }
);

export const DossierGetEffect = createEffect(
  (actions$ = inject(Actions), fibiiWebservice = inject(FibiiWebservice)) =>
    actions$.pipe(
      ofType(DossierGet),
      switchMap(({ redirectUrl }) =>
        fibiiWebservice.getDossiers().pipe(map((dossiers) => DossierGetSuccess({ dossiers, redirectUrl })))
      )
    ),
  { functional: true }
);

export const DossierGetSuccessEffect = createEffect(
  (actions$ = inject(Actions), router = inject(Router), route = inject(ActivatedRoute)) =>
    actions$.pipe(
      ofType(DossierGetSuccess),
      tap(({ redirectUrl }) => {
        if (redirectUrl) {
          router.navigate(redirectUrl, {
            relativeTo: route.parent,
          });
        }
      })
    ),
  { functional: true, dispatch: false }
);
